import Icon from '../components/Icon.vue'

Icon.register({
  archway: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-160c-8.8 0-16-7.2-16-16v-16l0-160c0-53-43-96-96-96s-96 43-96 96v176c0 8.8-7.2 16-16 16h-160c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h16v-352h512v352h16zM560 0c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-544c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h544z'
      }
    ]
  }
})
